import React from 'react';
import PropTypes from 'prop-types';
import { Icon, colors } from 'kangarootime-ui';
import { ClipLoader } from 'react-spinners';
import './SendMessage.css';

const ENTER_KEY = 13;

const SendMessage = ({
  placeholder,
  value,
  onSubmit,
  onFileSelect,
  loading,
  ...props
}) => {
  const fileInputRef = React.createRef();

  return (
    <div className='send-message-container'>
      <button className='send-message-button' onClick={event => fileInputRef.current.click()}>
        <Icon icon='add' color='#979797' />
      </button>
      <textarea
        name='message'
        className='send-message-textarea'
        onKeyDown={event => {
          let target = event.target;

          if (
            event.keyCode === ENTER_KEY &&
            target.value.trim() !== ''
          ) {
            event.preventDefault();

            onSubmit(target.value);

            target.value = '';
            target.style.height = `48px`; // value defined in SendMessage.css
          }

          // expand the textarea as the user types
          target.style.height = `${target.scrollHeight}px`;
        }}
        value={value}
        placeholder={`Message ${placeholder}`}
      />
      { loading && <ClipLoader size={24} sizeUnit='px' color={colors.brand_2} css={{ alignSelf: 'center', marginLeft: 4 }} /> }
      <input
        type='file'
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={onFileSelect}
        onClick={event => {
          event.target.value = null;
        }}
      />
    </div>
  );
};

SendMessage.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onSubmit: PropTypes.func,
  onAddAttachmentClick: PropTypes.func,
  loading: PropTypes.bool
};

export default SendMessage;
